<template>
  <div id="custom-components-container" class="relative overflow-hidden">
    <pdl-heading size="sm" level="3" class="my-2" qaid="custom-components-marketing-copy">
      {{ $t('product.fdp.customizable.components.message') }}
    </pdl-heading>

    <h4 class="text-md mb-2 font-medium">{{ $t('projectOne.buyingZone.customization.components') }}</h4>
    <customization-group
      v-for="component in componentOptions"
      :key="component.id"
      :option="component"
      group="components"
      @custom-component-selector="enterCustomComponentSelector"
    />
    <customization-group-selector
      :component-choices="componentChoices"
      :component-description="componentDescription"
      :is-drawer-open="isComponentSelectorDrawerOpen"
      :component-group-id="componentGroupId"
      @back-to-custom-components-list="backToComponentsList"
    />
  </div>
</template>

<script>
import CustomizationGroup from '@/components/containers/buy-zone/customization/CustomizationGroup.vue';
import CustomizationGroupSelector from '@/components/containers/buy-zone/customization/CustomizationGroupSelector.vue';
import {mapState, mapMutations} from 'vuex';
import {PdlHeading} from '@pedal/pdl-section-header';

export default {
  name: 'CustomComponentsContainer',
  components: {CustomizationGroup, CustomizationGroupSelector, PdlHeading},
  data() {
    return {
      customComponentsSelectorOptions: {},
      isComponentSelectorDrawerOpen: false,
    };
  },
  computed: {
    ...mapState('bikeCustomization', ['componentOptions']),

    componentChoices() {
      return this.customComponentsSelectorOptions?.choices;
    },
    componentDescription() {
      return this.customComponentsSelectorOptions?.description;
    },
    componentGroupId() {
      return this.customComponentsSelectorOptions?.id;
    },
  },
  methods: {
    ...mapMutations('bikeCustomization', ['setIsCustomizationDrawerOpen']),

    enterCustomComponentSelector(option) {
      this.customComponentsSelectorOptions = this.componentOptions.find((component) => {
        return component.description === option;
      });
      this.isComponentSelectorDrawerOpen = true;
      this.setIsCustomizationDrawerOpen(true);
    },
    backToComponentsList() {
      this.isComponentSelectorDrawerOpen = false;
      this.setIsCustomizationDrawerOpen(false);
      const DELAY_FOR_DRAWER_CLOSURE = 400;
      setTimeout(() => {
        this.customComponentsSelectorOptions = {};
      }, DELAY_FOR_DRAWER_CLOSURE);
    },
  },
};
</script>
